import {
  GetSourceFromUrlProps,
  getSourceFromUrl,
  makeUrl,
} from '$providers/Url/index';

export function makeUrlFromUrlFragment(props: GetSourceFromUrlProps) {
  const urlResolved = getSourceFromUrl(props);
  return makeUrl({ url: urlResolved });
}
